var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-save",
    transform: "translate(1690 -77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 37,
    height: 37,
    transform: "translate(-1690 77)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "save",
    d: "M23.271,8.688,19.312,4.729A.792.792,0,0,0,18.75,4.5H6.083A1.583,1.583,0,0,0,4.5,6.083V21.917A1.583,1.583,0,0,0,6.083,23.5H21.917A1.583,1.583,0,0,0,23.5,21.917V9.25A.792.792,0,0,0,23.271,8.688Zm-12.437-2.6h6.333V9.25H10.833Zm6.333,15.833H10.833V15.583h6.333Zm1.583,0V15.583A1.583,1.583,0,0,0,17.167,14H10.833A1.583,1.583,0,0,0,9.25,15.583v6.333H6.083V6.083H9.25V9.25a1.583,1.583,0,0,0,1.583,1.583h6.333A1.583,1.583,0,0,0,18.75,9.25V6.408l3.167,3.167V21.917Z",
    transform: "translate(-1685.5 81.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon-save.466119d8f2d3e8b6c0b757299d4b4de1.svg";
export { ForwardRef as ReactComponent };